<template>
  <div>
    <b-card>
      <b-card-title>
        <h4>Average: {{ driverRating }}</h4>
      </b-card-title>
      <b-table
        :fields="tableColumns"
        :items="reviewsArray"
        empty-text="No matching records found"
        class="text-center"
        responsive
      >
        <template #cell(status)="data">
          <b-button
            v-if="data.item.status== 'ACTIVE'"
            variant="flat-success"
            @click="deactivateReview(data.item)"
          >
            {{ data.item.status }}
          </b-button>
          <span v-else>{{ data.item.status }}</span>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import {
  BTable, BCard, BCardTitle, BButton,
} from 'bootstrap-vue'
import { computed } from '@vue/composition-api'
import formatDate from '@/utils/date-format'

export default {
  components: {
    BTable,
    BCard,
    BButton,
    BCardTitle,
  },
  props: {
    reviews: {
      type: Object,
      default: () => ({}),
    },
    driverRating: {
      type: [Number, String],
      default: null,
    },
  },
  methods: {
    async deactivateReview(review) {
      await this.$swal({
        title: 'Are you sure you want to deactivate?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, deactivate it!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
        showLoaderOnConfirm: true,
        preConfirm: res => {
          if (!res) return null
          return this.$store.dispatch('reviews/changeReviewStatus', {
            reviewableType: 'drivers',
            reviewableId: this.$route.query.externalId,
            externalId: review.trip_number,
            status: 'INACTIVE',
          }).catch(err => {
            console.log(err.response)
            this.$swal.showValidationMessage(err.response.data.error.errors.at(0).message)
          })
        },
      }).then(result => {
        if (result.value) {
          this.$emit('refetch-reviews')
          this.$swal({
            icon: 'success',
            title: 'Deactivated!',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
  },
  setup(props) {
    const tableColumns = [
      'trip_number',
      'rating',

      {
        key: 'createdAt',
        label: 'Created at',
        formatter: val => formatDate(val),
      },
      'status',
      'comment',
      'category',
      {
        key: 'actionBy',
        label: 'Email',
      },
      'subcategory',
    ]
    const reviewsArray = computed(() => {
      let arr = []
      if (props.reviews) {
        arr = Object.entries(props.reviews).map(([key]) => ({
          ...props.reviews[key],
          trip_number: key,
        }))
      }
      return arr
    })
    return {
      tableColumns,
      reviewsArray,
    }
  },
}
</script>
